<template>
  <div id="my-photo" class="my-photo">
    <div
      class="my-photo-content"
      :class="{
        'empty': isEmpty
      }"
    >
      <div class="img-list">
        <div
          v-for="(item) in uploadedImages"
          class="img-item"
          :class="{
            'selected': item.name === selectedImage.name
          }"
          :key="item.name"
          @click="toggleSelectExistImage(item)"
        >
          <div
            class="bg-placeholder"
            :style="{
              'background-image': 'url(' + getThumbnail(item) + ')'
            }"
          ></div>
          <span class="checkmark">
            <i class="fa fa-check"></i>
          </span>
        </div>
      </div>

      <div
        v-if="isEmpty"
        class="my-photo-empty"
      >
        <img
          src="@/assets/images/img-library/no-photo.png"
          alt=""
          class="inline-block"
          width="200"
        >
        <p class="font-bold">
          {{ $i18nPresenter.t('A picture is worth a thousand words.') }}
        </p>
        <AhaButton
          class="my-photo-upload"
          @click="handleTabChange"
        >
          {{ $i18nPresenter.t('Upload now') }}
        </AhaButton>
      </div>

      <Loading
        class="loader"
        :class="{
          'hidden': !isLoading
        }"
      />
    </div>

    <div
      class="my-photo-footer"
      :class="{
        'hidden': !uploadedImages.length
      }"
    >
      <AhaButton
        class="px-11"
        :disabled="!selectedImage.name || isSelectingImage"
        @click="handleAddSelectedPhoto"
      >
        <span
          v-if="isSelectingImage"
          class="loading-spinner mr-2"
        ></span>
        Select
      </AhaButton>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
import utils from '@/util'
import constants from '@/constant'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      uploadedImages: [],
      selectedImage: {},
      isLoading: false,
      isEmpty: false,
      isSelectingImage: false,
    }
  },
  mounted() {
    this.getUploadedImages()
    EventBus.$on('selectedMyPhotoItem', () => {
      this.isSelectingImage = false
    })
  },
  destroyed() {
    EventBus.$off('selectedMyPhotoItem')
  },
  methods: {
    getThumbnail(item) {
      return item.name.split('.').pop() === 'gif'
        ? item.origin
        : item.thumbnail
    },
    async getUploadedImages() {
      this.isLoading = true
      try {
        const res = await this.$http.get(Config.api.getUploadedImages)
        this.uploadedImages = Array.isArray(res.body) ? res.body : []

        if (!this.uploadedImages.length) {
          this.isEmpty = true
        }
      } catch (err) {
        // console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    toggleSelectExistImage(obj) {
      if (this.selectedImage && this.selectedImage.name === obj.name) {
        this.selectedImage = {}
      } else {
        this.selectedImage = obj
      }
    },
    handleAddSelectedPhoto() {
      this.isSelectingImage = true
      this.$emit('selectExistImage', this.selectedImage)
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_EDITOR,
        'My photo > Insert photo',
        this.selectedImage.name,
      )
    },
    handleTabChange() {
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_EDITOR,
        'My photo > Click upload',
      )
      this.$emit('changeUploadTab')
    },
  },
}
</script>

<style lang="scss" scoped>
$footer-height: 72px;
$padding-bottom: 24px; // affected by modal

.my-photo {
  min-height: 330 + $padding-bottom;
  @apply -mb-6;

  .loader {
    @apply absolute left-0 my-0 mx-auto w-full;
    bottom: 4.5rem !important;
  }
}

.my-photo-content {
  overflow-y: auto;
  padding: 0 32px;
  height: 330px - $footer-height + $padding-bottom;
  margin-top: 24px;

  &.empty {
    height: 330px + $padding-bottom;
    padding-top: 0;
    padding-bottom: 40px;
  }
}

.img-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.img-item {
  background-image: url('~@/assets/images/bg-tile-dark.png');
  height: 160px;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &.selected {
    .bg-placeholder {
      border: 4px solid #348EF6;
    }

    .checkmark {
      visibility: visible;
    }
  }
}

.bg-placeholder {
  @apply absolute top-0 right-0 bottom-0 left-0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-origin: border-box;
}

.checkmark {
  visibility: hidden;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #348EF6;
  color: #fff;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 4px;
}

.my-photo-footer {
  height: $footer-height;
  @apply flex justify-end items-center px-8;
}

#my-photo .my-photo-empty {
  text-align: center;
  padding-top: 60px;

  p {
    margin-top: 0.875rem !important;
    margin-bottom: 0.875rem !important;
  }
}

.my-photo-upload {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
